import { getTypedState } from 'ducks/hooks'
import { DiscountsType } from './types'

export const getDiscountsValue = (type: keyof DiscountsType) => (): any => {
  const { discounts } = getTypedState()
  // if (!orderMaintenance) return null
  return discounts[type as keyof DiscountsType]
}
